(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-service/assets/javascripts/get-banner-type.js') >= 0) return;  svs.modules.push('/components/content/banner-service/assets/javascripts/get-banner-type.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  var layouts = {
    background: 'background',
    column: 'column',
    slimBanner: 'slimBanner',
    quickplay: 'quickplay'
  };

  function getBannerType(banner) {
    var hasImageOrVideo = banner.images && banner.images[100] || banner.video,
        hasBackgroundImage = banner.images && banner.images[200];

    var hasBagType = function hasBagType(bagType) {
      return banner.bagType && banner.bagType.includes(bagType);
    };

    if (hasBagType('rubbet') && hasBackgroundImage) {
      return {
        name: 'rubbet',
        path: 'tur/banner-type-bag',
        partialLayout: layouts.background,
        partialName: 'components-tur-banner_type_bag-banner_rubbet'
      };
    }

    if (hasBagType('lordagsgodis') && hasBackgroundImage) {
      return {
        name: 'lordagsgodis',
        path: 'tur/banner-type-bag',
        partialLayout: layouts.background,
        partialName: 'components-tur-banner_type_bag-banner_lordagsgodis'
      };
    }

    if (hasBagType('xperten') && hasBackgroundImage) {
      return {
        name: 'xperten',
        path: 'sport/banner-type-xperten',
        partialLayout: layouts.background,
        partialName: 'components-sport-banner_type_xperten-banner_xperten'
      };
    }

    if (banner.subtype === 'trissDirectPlay' && hasBackgroundImage) {
      return {
        name: 'trissDirectPlay',
        path: 'tur/banner-type-trissdirectplay',
        partialLayout: layouts.background,
        partialName: 'components-tur-banner_type_trissdirectplay-banner_trissdirectplay'
      };
    }

    if (banner.oddsetMatchId && hasBackgroundImage) {
      return {
        name: 'oddset-playable',
        path: 'sport/banner-type-oddset-playable',
        partialLayout: layouts.background,
        partialName: 'components-sport-banner_type_oddset_playable-banner_oddset_playable'
      };
    }

    if (banner.formLinkForm && (hasImageOrVideo || hasBackgroundImage)) {
      return {
        name: 'form',
        path: 'content/banner-type-form',
        partialLayout: hasBackgroundImage ? layouts.background : layouts.column,
        partialName: 'components-content-banner_type_form-banner_form'
      };
    }

    if (banner.subtype === 'slimBanner') {
      return {
        name: 'slimBanner',
        path: 'content/banner-type-slimbanner',
        partialLayout: layouts.slimBanner,
        partialName: 'components-content-banner_type_slimbanner-banner_slimbanner'
      };
    }

    if (banner.c2a && hasBackgroundImage) {
      return {
        name: 'background',
        path: 'content/banner-type-background',
        partialLayout: layouts.background,
        partialName: 'components-content-banner_type_background-banner_background'
      };
    }

    if (banner.c2a && hasImageOrVideo) {
      return {
        name: 'column',
        path: 'content/banner-type-column',
        partialLayout: layouts.column,
        partialName: 'components-content-banner_type_column-banner_column'
      };
    }

    if (banner.quickPlayProductId) {
      return {
        name: 'quickplay',
        path: 'content/banner-type-quickplay',
        partialLayout: layouts.quickplay,
        partialName: 'components-content-banner_type_quickplay-banner_quickplay'
      };
    }

    throw new Error('Unrecognized banner type');
  }

  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
    module.exports = getBannerType;
  } else {
    svs.content.bannerService.getBannerType = getBannerType;
  }
})();
 })(window);